import React from 'react';
import { ErrorBoundary } from '@components/ErrorBoundary';
import { FabricThemeProvider } from '@fabric-ui/theme';
import AvDebugProvider from './context/AvDebugProvider';
import AvQueryProvider from './context/AvQueryProvider';
import { NetworkStatusProvider } from './context/NetworkStatusContext';
import AvNotificationProvider from './context/NotificationProvider';
import './index.css';
import { RouterContextProvider } from './RouterContext';

export const RouterOuterWrapper = ({ children }: React.PropsWithChildren) => (
  <FabricThemeProvider>
    <ErrorBoundary>
      <AvDebugProvider>
        <AvNotificationProvider>
          <NetworkStatusProvider>
            <AvQueryProvider>
              <RouterContextProvider>{children}</RouterContextProvider>
            </AvQueryProvider>
          </NetworkStatusProvider>
        </AvNotificationProvider>
      </AvDebugProvider>
    </ErrorBoundary>
  </FabricThemeProvider>
);
